import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link ShowSnackbarCommand}
 */
export type ShowSnackbarCommandProperties = CommandProperties;

/**
 * Command to show database-related snackbars in the native embed experience.
 *
 * This command displays notification messages for database operations such as
 * successful saves, error messages, or other status updates, ensuring they
 * appear in the host application's notification system.
 */
export const ShowSnackbarCommand = createCommand<ShowSnackbarCommandProperties, void>(
  'show-snackbar-command'
);
